import {
  getSelectDropdownListFloatingConfig,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY,
  SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY_WITH_ADDITIONAL_INFO,
} from '../../Select'

const INVOICE_MODAL_SELECT_DROPDOWN_MIN_HEIGHT = 56

export const INVOICE_MODAL_SELECT_DROPDOWN_FLOATING_CONFIG =
  getSelectDropdownListFloatingConfig(
    SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY,
    INVOICE_MODAL_SELECT_DROPDOWN_MIN_HEIGHT
  )

export const INVOICE_MODAL_SUPPLIER_SELECT_DROPDOWN_FLOATING_CONFIG =
  getSelectDropdownListFloatingConfig(
    SELECT_DROPDOWN_LIST_MAX_HEIGHT_AVATARED_ENTITY_WITH_ADDITIONAL_INFO,
    INVOICE_MODAL_SELECT_DROPDOWN_MIN_HEIGHT
  )
